import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import CheckboxContent from "./CheckboxContent.model";
import styles from "./Checkbox.module.scss";
import combineClasses from "helpers/combine-classes";

const Checkbox: FunctionComponent<CheckboxContent> = (props) => {
    const { setFormFieldsState, formFieldsState, setRequiredFieldsEach, requiredFieldsEach, setIsAlert, isAlert, resetFields } = props;
    const [checked, setChecked] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (resetFields && ref.current) { setChecked(false); }
    }, [resetFields]);

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const el = e.target as HTMLInputElement;

        const includesAlias = requiredFieldsEach.length > 0 ? requiredFieldsEach.includes(props.alias) : false;
        if (props.mandatory && el.value.length > 0 && !includesAlias){
            setRequiredFieldsEach([...requiredFieldsEach, props.alias]);
        }

        if (props.mandatory && !el.checked && includesAlias) {
            setRequiredFieldsEach(requiredFieldsEach.filter(e => e !== props.alias));
            setIsAlert(true);
        }

        setFormFieldsState({ ...formFieldsState, [el.name]: el.checked });
    };

    const handleChecked = (e: React.FormEvent<HTMLInputElement>) => {
        setChecked(!checked);
    };

    const alertClass = !checked && props.mandatory && isAlert ? styles.alert : undefined;

    return (
        <div>
            <div className={styles.label_wrapper}>
                <span >{props.caption}</span> {props.mandatory ? (<span className={styles.mandatory}>*</span>) : null}
            </div>
            <div className={styles.radio_buttons} onChange={handleChange}>
                {/* Checkbox Button */}
                <div >
                    <label>
                        <input ref={ref} checked={checked} onChange={handleChecked} type="checkbox" className={combineClasses([styles.radio_button, alertClass])} name={props.alias} />{props.settings.defaultValue ? props.settings.defaultValue : props.settings.acceptCopy}
                    </label>
                </div>

            </div>
        </div>
    );
};

export default Checkbox;
